import { render, staticRenderFns } from "./ManageUserFeatureFlagOverrides.vue?vue&type=template&id=5b95f2a2"
import script from "./ManageUserFeatureFlagOverrides.vue?vue&type=script&lang=js"
export * from "./ManageUserFeatureFlagOverrides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports